var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGolf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Golf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Golf",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_golf-course_799831_000000",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0002117,27.3004021 C19.726979,27.3004021 18.4785523,27.3417413 17.2714407,27.4161519 C17.073014,27.4326872 16.8828545,27.5153671 16.7423028,27.6476513 L10.5001693,33.6002286 L10.5001693,14.0221673 L19.6775363,10.3512702 C20.4712431,10.028827 21.000381,9.25993618 21.000381,8.40006773 C21.000381,7.54019928 20.4794977,6.77130002 19.6775363,6.44886523 L10.5001693,2.77796816 L10.5001693,0.843317053 C10.5001693,0.372046661 10.1281177,0 9.65685057,0 L7.14344575,0 C6.68042895,0 6.30012699,0.372050894 6.30012699,0.843317053 L6.30012699,29.4167038 C2.41426556,30.7478003 0,32.5997791 0,34.6500783 C0,38.7095311 9.40045153,42 21,42 C32.5995485,42 42,38.7094465 42,34.6500783 C42,30.5907102 32.5995485,27.3001566 21,27.3001566 L21.0002117,27.3004021 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,20 C35,21.6567044 33.6567044,23 32,23 C30.3432956,23 29,21.6567044 29,20 C29,18.3432956 30.3432956,17 32,17 C33.6567044,17 35,18.3432956 35,20",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default ForwardRef;